export default "__VITE_ASSET__aYP01cS0__"